import React from 'react';
import { useAppSelector } from '../store/hooks';
import { selectModalOnboarding, selectModalPractice } from '../store/onboardingSlice';
import { selectBaseUrl, selectStageCheckList } from '../store/registrationCompleteSlice';
import { GenericUpdateForm } from '../OnboardingViewModal';
import { Checklist } from './OnboardingViewHelpers';
import './RegistrationCompleteModal.css';

const RegistrationCompleteModal = () => {
  // Redux state
  const modalOnboarding = useAppSelector(selectModalOnboarding);
  const modalPractice = useAppSelector(selectModalPractice);
  const baseUrl = useAppSelector(selectBaseUrl);
  const stageCheckList = useAppSelector(selectStageCheckList);

  console.log("RegistrationCompleteModal: ", modalOnboarding, modalPractice);

  // Get registration complete data from the onboarding object
  const registrationComplete = modalOnboarding?.stages?.registrationComplete?.status;

  const formatBoolean = (value) => {
    return value ? 'Completed' : 'No';
  };

  return (
    <div className="space-y-4">
      
      { modalOnboarding && (
        <div>
          <p className={`registration-complete-status${registrationComplete ? ' registration-complete-status-active' : ' registration-complete-status-inactive'}`}>{formatBoolean(registrationComplete)}</p>
          <GenericUpdateForm onboarding={modalOnboarding} stage="registrationComplete" baseUrl={baseUrl} />
          
          {/* Checklist Component */}
          <Checklist 
            stage="registrationComplete" 
            onboarding={modalOnboarding} 
            stateCheckList={stageCheckList} 
          />
        </div>
      )}
    </div>
  );
};

export const displayHistoryRegistrationComplete = (onboarding) => {
  // For now, return a simple table row with placeholder data
  // In the future, this would parse actual history data from the onboarding object
  return (
    <tr className="registration-complete-history-row">
      <td className="registration-complete-history-cell">
        {new Date().toLocaleString()}
      </td>
      <td className="registration-complete-history-cell">
        Not set
      </td>
      <td className="registration-complete-history-cell">
        {onboarding.registrationComplete ? '✅' : '❌'}
      </td>
      <td className="registration-complete-history-cell">
        Initial status
      </td>
    </tr>
  );
};

export { RegistrationCompleteModal };
